module.exports = __webpack_public_path__ + "static/media/Entomological Society of America Logo.b9770e6a.jpg";